export enum ClientsApiMethods {
    getClients = 'Clients.GetClients',
}
